import { Image, Music, Video } from "lucide-react";
import { Badge } from "../ui/badge";
import {
	Card,
	CardContent,
	CardDescription,
	CardHeader,
	CardTitle,
} from "../ui/card";
import type { GenerationTab } from "./PlaygroundTopBar";

interface ComingSoonProps {
	type: GenerationTab;
}

const CONFIG: Record<
	string,
	{ icon: React.ElementType; title: string; description: string }
> = {
	image: {
		icon: Image,
		title: "Image Generation",
		description:
			"Generate images from text prompts using DALL-E, Stable Diffusion, Midjourney and more. Create artwork, product mockups, and visual content.",
	},
	audio: {
		icon: Music,
		title: "Audio Generation",
		description:
			"Convert text to speech, generate music, and create audio content using advanced AI models. Perfect for podcasts, voiceovers, and sound design.",
	},
	video: {
		icon: Video,
		title: "Video Generation",
		description:
			"Create videos from text descriptions using cutting-edge AI. Generate explainer videos, animations, and visual content at scale.",
	},
};

export function ComingSoon({ type }: ComingSoonProps) {
	const config = CONFIG[type];
	if (!config) return null;

	const Icon = config.icon;

	return (
		<div className="flex items-center justify-center h-full bg-muted/30">
			<Card className="max-w-md text-center">
				<CardHeader>
					<div className="mx-auto w-16 h-16 rounded-full bg-primary/10 flex items-center justify-center mb-4">
						<Icon className="h-8 w-8 text-primary" />
					</div>
					<div className="flex items-center justify-center gap-2">
						<CardTitle>{config.title}</CardTitle>
						<Badge variant="secondary">Coming Soon</Badge>
					</div>
					<CardDescription className="mt-2">
						{config.description}
					</CardDescription>
				</CardHeader>
				<CardContent>
					<p className="text-sm text-muted-foreground">
						This feature is currently under development. We're working hard to
						bring you the best experience.
					</p>
					<div className="mt-4 flex items-center justify-center gap-2">
						<div className="w-2 h-2 rounded-full bg-primary animate-pulse" />
						<span className="text-xs text-muted-foreground">
							In Development
						</span>
					</div>
				</CardContent>
			</Card>
		</div>
	);
}
